module.exports = __webpack_public_path__ + "img/ethereum.888df991.png";